import React, { useState } from 'react'
import {TextField, InputAdornment, IconButton} from '@material-ui/core'
import {Person, Lock} from '@material-ui/icons'
import Button from 'react-bootstrap/Button';
import {useFormik} from 'formik';
import *as Yup from 'yup';
import SubmitForm from './SubmitForm';
import '../App1.css';

const Login = () => {

  const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Emaili nuk eshte valid!")
        .required("Sheno emailin"),
      password: Yup.string().min(5).required("Sheno passwordin"),
    }),

    onSubmit: (values) => {
      console.log(values);
      setIsSubmitSuccess(true)
    },
  });

  return (

    <div className="container" style={{backgroundColor:'darkgray', borderRadius:'70px', marginTop:'20px'}}>
      <div className={!isSubmitSuccess ? "signin signin_wrapper" : "signin signin_success"} style={{padding:"100px"}}>
        {isSubmitSuccess ? (
          <SubmitForm />
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <h2>Login Form</h2>
            <TextField
              name="email"
              type="text"
              placeholder="Email"
              className="textField"
              InputProps={{
                startAdornment: (
                  <InputAdornment>
                    <IconButton>
                      <Person />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />

            {formik.touched.email && formik.errors.email ? (
              <div className="error_msg">{formik.errors.email}</div>
            ) : null}

            <TextField
              name="password"
              type="password"
              placeholder="Password"
              className="textField"
              InputProps={{
                startAdornment: (
                  <InputAdornment>
                    <IconButton>
                      <Lock />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="error_msg">{formik.errors.password}</div>
            ) : null}

            <br/>

              <Button variant="dark" type="submit">Login</Button>
            {/* <h3> Not a member? <span className="signup">Signup now</span></h3> */}
          </form>
        )}
      </div>
    </div>
  );
};

export default Login